/*eslint-disable*/ export const messages = JSON.parse("{\"page-indicator.aria.label\":[\"Prick \",[\"selectedPage\"],\" är markerad i en rad med \",[\"pageCount\"],\" prickar\"]}");
//# sourceMappingURL=messages.mjs.map